<template>
  <div style="padding: 20px;">
    <LoaderView v-if="meal == null && !loadError" />

    <div v-else-if="loadError" class="meal-error">
      <strong>Impossible d’afficher ce repas.</strong>
      <span>Réessaie dans quelques secondes.</span>
      <button class="button" @click="reload">Réessayer</button>
    </div>

    <div v-else>
      <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 1rem; justify-content: space-between;">
        <!-- Go back-->
        <button class="button gray" @click="$router.go(-1)">
          <font-awesome-icon class="icon" :icon="['fas', 'arrow-left']" />
          Retour
        </button>

        <div class="form-title" style="text-align: center;">
          Mon {{ mealDisplay }} du {{ humanizeDate(dateParam) }}
        </div>

        <div />
      </div>

      <!-- 🥘 DishCard (corrigé avec les 3 props obligatoires) -->
      <DishCard v-for="(dishItem, index) in meal" :key="index" :recipe="dishItem.dish" :item="dishItem"
        :adjustedIngredients="dishItem.ajusted_ingredients" :peopleCount="peopleCount" @update="reload" />
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import LoaderView from "@/components/LoaderView.vue";
import DishCard from "@/views/DishCard.vue";

export default {
  name: "MyMealView",
  components: {
    LoaderView,
    DishCard,
  },
  data() {
    return {
      meal: null,
      peopleCount: null,
      loadError: false,
    };
  },
  computed: {
    dateParam() {
      return this.$route.params.date;
    },
    mealParam() {
      return this.$route.params.meal;
    },
    mealDisplay() {
      return {
        lunch: "Déjeuner",
        dinner: "Dîner",
        diner: "Dîner",
        breakfast: "Petit déjeuner",
        snack: "Goûter",
      }[this.mealParam];
    },
  },
  mounted() {
    this.reload();
    this.loadHousehold();
  },
  methods: {
    loadHousehold() {
      api.get("/me/").then((response) => {
        const consumers = response.data?.consumer_account?.consumers;
        this.peopleCount = Array.isArray(consumers) ? consumers.length : null;
      }).catch(() => {
        this.peopleCount = null;
      });
    },
    reload() {
      this.meal = null;
      this.loadError = false;
      api
        .get(`/my-meal/${this.dateParam}/${this.mealParam}/`)
        .then((response) => {
          this.meal = response.data;
        })
        .catch(() => {
          this.loadError = true;
        });
    },
    humanizeDate(isoDate) {
      const date = new Date(isoDate);
      return date.toLocaleDateString("fr-FR", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    },
  },
};
</script>

<style scoped>
.menu-item-image {
  width: 200px;
  object-fit: cover;
  margin-right: 20px;
  border-radius: 10px;
}

.menu-item-name {
  font-size: 20px;
  font-weight: bold;
  color: #3c6610;
  margin-bottom: 1rem;
}

.menu-item-ingredients {
  font-size: 14px;
}
.meal-error {
  display: grid;
  gap: 8px;
  justify-items: start;
  padding: 18px;
  border: 1px solid #ead8d2;
  border-radius: 12px;
  background: #fff8f5;
  color: #6f493d;
}
.meal-error span { color: #7d6b65; }
</style>
